import {FC, MouseEvent, useState} from 'react';
import {useRecoilState, useSetRecoilState} from 'recoil';

import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Stack from '@mui/system/Stack';
import Button from '@mui/material/Button';

import {
  contactPersonsToSubmitState,
  currentContactPersonIdState,
} from '../../../../../../../store/contact-person/atoms';
import ContactPersonEditModal from '../ContactPersonEditModal/ContactPersonEditModal';
import {ContactPersonRow} from './ContactPersonRow';

interface ITableBodyContactPerson {
  handleOpen: (e: MouseEvent<unknown>) => void;
}

const TableBodyContactPerson: FC<ITableBodyContactPerson> = ({handleOpen}) => {
  const [contactPersons, setContactPersons] = useRecoilState(contactPersonsToSubmitState);
  const [open, setOpen] = useState(false);
  const setCurrentContactPersonId = useSetRecoilState(currentContactPersonIdState);

  const handleOpenEdit = (id: string) => (e: MouseEvent<HTMLTableRowElement | HTMLButtonElement>) => {
    e.stopPropagation();

    setCurrentContactPersonId(id);
    setOpen(true);
  };

  const handleCloseEdit = () => {
    setCurrentContactPersonId('');
    setOpen(false);
  };

  const deleteContactPerson = (id: string) => (e: MouseEvent<HTMLTableRowElement | HTMLButtonElement>) => {
    e.stopPropagation();

    setContactPersons((prev) => prev.filter((i) => i.id !== id));
  };

  return (
    <>
      <TableBody>
        {contactPersons.map((row) => (
          <ContactPersonRow
            key={row.id}
            row={row}
            handleClickEdit={handleOpenEdit(row.id)}
            handleClickDelete={deleteContactPerson(row.id)}
          />
        ))}
        <TableRow
          sx={{
            height: 53,
          }}
        >
          <TableCell colSpan={6}>
            <Stack direction="row" sx={{justifyContent: 'center'}}>
              <Button data-testid="addContactPerson" onClick={handleOpen}>
                Добавить
              </Button>
            </Stack>
          </TableCell>
        </TableRow>
      </TableBody>
      {open && <ContactPersonEditModal open={open} handleClose={handleCloseEdit} />}
    </>
  );
};

export default TableBodyContactPerson;
